import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FHashtag from '~/js/components/hashtag'
import FModal from '~/js/components/modal'

const CLASS_NAME = 'js-indexHashtags'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    createApp({
      name: 'TemplatesIndexHashtags',
      components: {
        FButton,
        FHashtag,
        FModal,
      },
    }).mount(element)
  })
})
